import React, { Component } from "react";
import { getUsersApi, exportUsers } from "../../../api/userService";
import Pagination from "../../../components/Pagination/Pagination";
import { withRouter } from "../../../utils/withRouter";
import Button from "../../../utils/Buttons";
import { getErrorMessage } from "../../../utils/errorHandler";

class Users extends Component {
  state = {
    users: [],
    loading: true,
    error: null,
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    successMessage: "",
    errorMessage: "",
    selectedStatus: "",
    showStatusModal: false,
    selectedUser: null,

    statusOptions: [
      "ACTIVE",
      "INACTIVE",
      "ARCHIVED",
      "THRASHED",
      "DELETED",
      "PENDING",
      "DISAPPROVED",
    ],
  };

  componentDidMount() {
    this.loadUsers();
  }

  loadUsers = async () => {
    const { currentPage, itemsPerPage } = this.state;

    try {
      this.setState({ loading: true });

      const res = await getUsersApi({
        page: currentPage,
        pageSize: itemsPerPage,
      });

      const users = Array.isArray(res?.data) ? res.data : [];

      this.setState({
        users,
        totalItems: res?.pagination?.totalItems || users.length,
        loading: false,
        error: null,
      });
    } catch (error) {
      console.log("LOAD USERS ERROR :", error);
      alert(getErrorMessage(error));
    }
  };
  handlePageChange = (page) => {
    this.setState(
      {
        currentPage: page,
      },
      () => {
        this.loadUsers();
      },
    );
  };

  handleView = (user) => {
    if (!user?._id) {
      alert("Invalid user id");
      return;
    }

    this.props.navigate(`/users/admin/view/${user.name}`, {
      state: {
        userId: user._id,
      },
    });
  };

  handleExportUser = async () => {
    try {
      const response = await exportUsers();

      const blob = new Blob([response.data], {
        type: "text/csv",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];

      let fileName = "users.csv";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };

  render() {
    const {
      users,
      loading,
      error,
      itemsPerPage,
      currentPage,
      totalItems,
      successMessage,
      errorMessage,
    } = this.state;

    if (loading) {
      return (
        <div className="d-flex vh-100 w-100 align-items-center justify-content-center">
          <p className="m-0">Loading Users...</p>
        </div>
      );
    }

    if (error) {
      return <p className="text-danger">{error}</p>;
    }

    return (
      <div className="container-fluid p-4 np-users-page">
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

        <div className="d-flex justify-content-end align-items-center mb-3">
          <button className="btn btn-success" onClick={this.handleExportUser}>
            Export CSV
          </button>
        </div>

        <div className="card p-3">
          <table className="table table-bordered table-hover">
            <thead className="bg-light">
              <tr>
                <th className="text-dark fw-bold">Sr No</th>
                <th className="text-dark fw-bold">Full Name</th>
                <th className="text-dark fw-bold">Email</th>
                <th className="text-dark fw-bold">Phone</th>
                <th className="text-dark fw-bold">Action</th>
              </tr>
            </thead>

            <tbody>
              {users.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center">
                    No users found
                  </td>
                </tr>
              )}

              {users.map((user, index) => (
                <tr key={user._id || index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                  <td>{user.name || "-"}</td>
                  <td>{user.email || "-"}</td>
                  <td>{user.phone || "-"}</td>

                  <td className="text-center">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      <Button
                        icon={<i className="fe fe-eye" title="View"></i>}
                        className="btn btn-sm np-table-action-btn"
                        onClick={() => this.handleView(user)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={this.handlePageChange}
        />
      </div>
    );
  }
}

export default withRouter(Users);
